<ng-container *ngIf="indeterminate">
  <app-icon color="ink-45" hoverColor="ink-45" size="small">remove_circle</app-icon>
</ng-container>
<ng-container *ngIf="!indeterminate">
  <app-icon *ngIf="value" color="system-green" hoverColor="system-green" size="small">check_circle</app-icon>
  <app-icon *ngIf="!value" color="ink-70" hoverColor="ink-70" size="small">cancel</app-icon>
</ng-container>
